import styled from "styled-components";

import designSystemColors from "../../styles";

export const Container = styled.div`
  width: 100%;
  background-color: ${designSystemColors.textGeneralButtons};
  display: flex;
  flex-wrap: wrap;
  padding: 16px;
  box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
`;

export const TitleWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`;

export const PageTitle = styled.h1`
  margin: 0;
  font-size: 24px;
  color: ${designSystemColors.textDark};
  font-weight: bold;
  line-height: 20px;
`;

export const FilterCard = styled.div`
  width: 100%;
  margin-top: 24px;
  background-color: ${designSystemColors.background};
  box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.15);
  border-radius: 8px;
  padding: 20px 24px;
`;

export const FilterRow = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 16px;

  .ant-picker {
    border-radius: 8px;
    width: 150px;
  }
`;

export const FilterField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex-shrink: 0;

  label {
    font-size: 13px;
    font-weight: 600;
    color: ${designSystemColors.textDescription};
  }
`;

export const ApplyButton = styled.button`
  flex-shrink: 0;
  margin-left: auto;
  width: 46%;
  max-width: 400px;
  height: 36px;
  border: none;
  border-radius: 8px;
  background-color: ${designSystemColors.generalButtons};
  color: ${designSystemColors.textGeneralButtons};
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.9;
  }

  &:disabled {
    background-color: ${designSystemColors.disabledButtons};
    cursor: not-allowed;
  }
`;

export const ChartCard = styled.div`
  width: 100%;
  margin-top: 16px;
  background-color: ${designSystemColors.background};
  box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  padding: 24px;
`;

export const ChartHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 24px;
  flex-wrap: wrap;
`;

export const ChartTitle = styled.h2`
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: ${designSystemColors.textDark};
`;

export const SummaryBadge = styled.div`
  background-color: ${designSystemColors.backgroundGray};
  border-radius: 8px;
  padding: 8px 16px;
  font-size: 13px;
  color: ${designSystemColors.textDescription};

  strong {
    color: ${designSystemColors.textDark};
  }
`;

export const EmptyState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 320px;
  color: ${designSystemColors.grayChart};
  font-size: 14px;
`;
